var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "repoTitleDevo", attrs: { md12: "" } },
                        [
                          _vm.mostrarModal === false &&
                          _vm.abrirModalEditar === false
                            ? _c("h2", { staticClass: "h2Devo" }, [
                                _vm._v(
                                  "\n              Reportes Técnicos\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm.mostrarModal
                            ? _c("h2", { staticClass: "h2Devo" }, [
                                _vm._v(
                                  "\n              Crear Reporte Técnico\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm.abrirModalEditar
                            ? _c("h2", { staticClass: "h2Devo" }, [
                                _vm._v(
                                  "\n              Editar Reporte Técnico\n            "
                                )
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            [
                              _vm.mostrarModal === false &&
                              _vm.abrirModalEditar === false &&
                              _vm.devolucionAnulada == false
                                ? _c(
                                    "v-btn",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mostrarBtnCrear,
                                          expression: "mostrarBtnCrear"
                                        }
                                      ],
                                      staticClass: "btnCrearDevo",
                                      on: {
                                        click: function($event) {
                                          _vm.mostrarModal = true
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { dark: "", left: "" } },
                                        [_vm._v("add_circle_outline")]
                                      ),
                                      _c("span", [_vm._v("Crear")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.mostrarModal || _vm.abrirModalEditar
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "btnCerrarDevo",
                                      on: {
                                        click: function($event) {
                                          ;(_vm.mostrarModal = false),
                                            (_vm.abrirModalEditar = false)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { dark: "", left: "" } },
                                        [_vm._v("undo")]
                                      ),
                                      _c("span", [_vm._v("Volver")])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.mostrarModal === false &&
                            _vm.abrirModalEditar === false,
                          expression:
                            "mostrarModal === false && abrirModalEditar === false"
                        }
                      ],
                      staticClass: "gridcard rounded-card dialogReporteTecnico"
                    },
                    [
                      _vm.accion == "crear" ||
                      (_vm.accion == "editar" && !_vm.devolucionAnulada)
                        ? _c("MantenedorGridSinCodigo", {
                            attrs: {
                              "grid-options": _vm.gridOptions,
                              funcionalidadId: _vm.funcionalidad,
                              quitarCheckOut: true
                            }
                          })
                        : _vm._e(),
                      _vm.accion == "ver" || _vm.devolucionAnulada
                        ? _c("MantenedorGrid", {
                            attrs: {
                              "grid-options": _vm.gridOptions,
                              funcionalidadId: _vm.funcionalidad
                            }
                          })
                        : _vm._e(),
                      _c("Confirmation", {
                        attrs: {
                          show: _vm.mostrarModalEliminacion,
                          titulo:
                            "¿Está seguro de eliminar el Reporte Técnico?",
                          mensaje: "Este cambio es irreversible",
                          textoBtnSi: "Continuar",
                          textoBtnNo: "Cancelar",
                          width: 450
                        },
                        on: { modalConfirmationEmit: _vm.eliminarReporte }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mostrarModal === true,
                          expression: "mostrarModal === true"
                        }
                      ],
                      attrs: { id: "divContDevo" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "Línea de Reporte",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.devoLinea,
                                  callback: function($$v) {
                                    _vm.devoLinea = $$v
                                  },
                                  expression: "devoLinea"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  label: "Técnico",
                                  items: _vm.tecnicosOptions,
                                  "item-text": "tecniconame",
                                  "item-value": "tecnicoid",
                                  dense: ""
                                },
                                model: {
                                  value: _vm.tecnico,
                                  callback: function($$v) {
                                    _vm.tecnico = $$v
                                  },
                                  expression: "tecnico"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  label: "Estado",
                                  items: _vm.estadosOptions,
                                  "item-text": "configvalor",
                                  "item-value": "configid",
                                  dense: ""
                                },
                                model: {
                                  value: _vm.devoRepoEstado,
                                  callback: function($$v) {
                                    _vm.devoRepoEstado = $$v
                                  },
                                  expression: "devoRepoEstado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha de Revisión",
                                  max: _vm.fechaMaxima
                                },
                                model: {
                                  value: _vm.devoRepoFecha,
                                  callback: function($$v) {
                                    _vm.devoRepoFecha = $$v
                                  },
                                  expression: "devoRepoFecha"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", sm3: "", md4: "", "mb-5": "" }
                            },
                            [
                              _c("v-textarea", {
                                staticClass: "textAreaDevo",
                                attrs: {
                                  label: "Observación",
                                  "no-resize": ""
                                },
                                model: {
                                  value: _vm.devoObs,
                                  callback: function($$v) {
                                    _vm.devoObs = $$v
                                  },
                                  expression: "devoObs"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", sm3: "", md4: "", "mt-4": "" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  attrs: {
                                    id: "btnSaveDevo",
                                    disabled: !(
                                      _vm.tecnico &&
                                      _vm.devoRepoEstado &&
                                      _vm.devoRepoFecha &&
                                      _vm.devoObs
                                    )
                                  },
                                  on: { click: _vm.ingresarReporte }
                                },
                                [
                                  _vm._v(
                                    "\n                GUARDAR REPORTE\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.abrirModalEditar === true,
                          expression: "abrirModalEditar === true"
                        }
                      ],
                      attrs: { id: "divContDevo" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "Línea de Reporte",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.devoLineaEdit,
                                  callback: function($$v) {
                                    _vm.devoLineaEdit = $$v
                                  },
                                  expression: "devoLineaEdit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  label: "Técnico",
                                  items: _vm.tecnicosOptions,
                                  "item-text": "tecniconame",
                                  "item-value": "tecnicoid",
                                  dense: ""
                                },
                                model: {
                                  value: _vm.tecnicoEdit,
                                  callback: function($$v) {
                                    _vm.tecnicoEdit = $$v
                                  },
                                  expression: "tecnicoEdit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  label: "Estado",
                                  items: _vm.estadosOptions,
                                  "item-text": "configvalor",
                                  "item-value": "configid",
                                  dense: ""
                                },
                                model: {
                                  value: _vm.devoRepoEstadoEdit,
                                  callback: function($$v) {
                                    _vm.devoRepoEstadoEdit = $$v
                                  },
                                  expression: "devoRepoEstadoEdit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha de Revisión",
                                  max: _vm.fechaMaxima
                                },
                                model: {
                                  value: _vm.devoRepoFechaEdit,
                                  callback: function($$v) {
                                    _vm.devoRepoFechaEdit = $$v
                                  },
                                  expression: "devoRepoFechaEdit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", sm3: "", md4: "", "mb-5": "" }
                            },
                            [
                              _c("v-textarea", {
                                staticClass: "textAreaDevo",
                                attrs: {
                                  label: "Observación",
                                  "no-resize": ""
                                },
                                model: {
                                  value: _vm.devoObsEdit,
                                  callback: function($$v) {
                                    _vm.devoObsEdit = $$v
                                  },
                                  expression: "devoObsEdit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", sm3: "", md4: "", "mt-4": "" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  attrs: {
                                    id: "btnSaveDevo",
                                    disabled: !(
                                      _vm.tecnicoEdit &&
                                      _vm.devoRepoEstadoEdit &&
                                      _vm.devoRepoFechaEdit &&
                                      _vm.devoObsEdit
                                    )
                                  },
                                  on: { click: _vm.editarReporte }
                                },
                                [
                                  _vm._v(
                                    "\n                GUARDAR CAMBIOS\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }